import { EContractorPaymentType } from "../contractor-payments";
import { schemes, zSchema } from "../schema-validation";
import { ETxnSpeed } from "../transaction-speeds";
import { EDisbursementMethod } from "../workers-shared";

export const createContractorPaymentSchema = zSchema.object({
  amount: zSchema.string().refine(
    (val) => {
      const num = parseFloat(val);
      return !Number.isNaN(num) && num > 0;
    },
    {
      message: "Amount must be greater than 0",
    }
  ),
  approval_required: zSchema.boolean().default(false),
  companyID: schemes.companyID(),
  contractorID: schemes.mongoObjectId(),
  disbursement: zSchema
    .object({
      method: zSchema.nativeEnum(EDisbursementMethod),
    })
    .optional(),
  pay_date: schemes.isoDate("Invalid pay date"),
  speed: zSchema.nativeEnum(ETxnSpeed).default(ETxnSpeed.TWO_DAY),
  type: zSchema
    .enum([
      EContractorPaymentType.REGULAR,
      EContractorPaymentType.REIMBURSEMENT,
    ] as const)
    .default(EContractorPaymentType.REGULAR),
  customerAccountID: schemes.uuid().optional(),
});
